module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "pref"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm02_pref"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("CULTURE, LABOR, HISTORY")]), _c('br'), _c('em', [_vm._v("General Editors:")]), _vm._v(" Daniel Bender and Kimberley L. Phillips")]), _vm._v(" "), _c('p', {
    staticClass: "pref"
  }, [_c('em', [_vm._v("Unknown Class:"), _c('br'), _vm._v("Undercover Investigations of American Work and Poverty"), _c('br'), _vm._v("from the Gilded Age to the Present")]), _c('br'), _vm._v("Mark Pittenger")]), _vm._v(" "), _c('p', {
    staticClass: "pref"
  }, [_c('em', [_vm._v("Working the Diaspora:"), _c('br'), _vm._v("The Impact of African Labor on the Anglo-American World,")]), _vm._v(" 1650∇1850"), _c('br'), _vm._v("Frederick C. Knight")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c19646","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm02_pref.vue
// module id = 63
// module chunks = 0